module.exports = __webpack_public_path__ + "img/13.a4ea5809.jpg";